import React from 'react'
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';a

const YesNoQuestion = ({ item, setItem }) => {
  // let activeAccordion = 'Intake Form';
  // const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  return (
    <div className="d-flex gap-15">
        <p className="text fs-14 ar-light-color w-231px text-end">{item.content}</p>
        <p className="text text-black fs-14">{item.answer || 'N/A'}</p>
    </div>
  );
};

export default YesNoQuestion;